import { render, staticRenderFns } from "./WorkflowDocButtons.vue?vue&type=template&id=56762e9f&scoped=true"
import script from "./WorkflowDocButtons.vue?vue&type=script&lang=js"
export * from "./WorkflowDocButtons.vue?vue&type=script&lang=js"
import style0 from "./WorkflowDocButtons.vue?vue&type=style&index=0&id=56762e9f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56762e9f",
  null
  
)

export default component.exports